<template>
  <v-menu
    absolute
    max-height="75%"
    offset-y
    min-width="250"
  >
    <!-- pass thru activator slot -->
    <template #activator="slotData">
      <slot
        name="activator"
        v-bind="slotData"
      />
    </template>

    <!-- TagNote List -->
    <v-list>
      <v-list-item-group
        active-class="primary--text"
      >
        <template v-for="(item, i) in tagNotes">
          <v-list-item
            :key="i"
            :value="item.text"
            @click="selected(item)"
          >
            <v-list-item-title>
              {{ item.text }}
            </v-list-item-title>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script lang='ts'>
import Vue, { PropType } from 'vue';
import TagNote from '@/model/TagNote';

export default Vue.extend({
  name: 'TagNoteMenu',
  components: { },
  props: { },
  data() {
    return { };
  },
  computed: {
    tagNotes(): TagNote[] { return this.$tstore.state.settings.tagNotes; },
  },
  methods: {
    selected(t: TagNote) {
      this.$emit('selected', t);
    },
  },
});
</script>
